import employees from './employees/en';
import dataTable from './dataTable/en';
import customers from './customers/en';
import login from './login/en';
import projectManagement from './projectManagement/en';
import profilePage from './profilePage/en';
import visitModal from './visitModal/en';
import cargo from './cargo/en';
import operations from './operations/en';
import quality from './quality/en';
import smoLead from './smoLead/en';
import regionReports from './regionReports/en';
import loginReminders from './loginReminders/en';
import leaves from './leaves/en';
import stock from './stock/en';
import tariffs from './tariffs/en';
import centers from './centers/en';
import budget from './budget/en';
import userGuide from './userGuide/en';
import errorReports from './errorReports/en';
import pageAccess from './pageAccess/en';
import todo from './todo/en';
import insurance from './insurance/en';
import educationReports from './educationReports/en';
import bankAccounts from './bankAccounts/en';
import employeeFinance from './employeeFinance/en';
import salaryPayment from './salaryPayment/en';
import projectFinance from './projectFinance/en';
import fieldExpenses from './fieldExpenses/en';
import externalPersonnel from './externalPersonnel/en';
import employeeReports from './employeeReports/en';
import employeeAnalysis from './employeeAnalysis/en';
import dataEntryValues from './dataEntryValues/en';

// English texts. Keys mirror tr.js; `_one` / `_other` variants are picked by `count`.
const en = {
  common: {
    close: 'Close',
    user: 'User',
    view: 'View',
    active: 'Active',
    passive: 'Inactive',
    all: 'All',
    retry: 'Try again',
    clearSearch: 'Clear search',
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
      night: 'Good evening',
    },
  },
  language: {
    label: 'Language',
  },
  shell: {
    mainMenu: 'Main menu',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    expandMenu: 'Expand menu',
    collapseMenu: 'Collapse menu',
    portal: 'Portal',
    hall: 'Hall — choose a system',
    home: 'Home',
    signOut: 'Sign out',
    signingOut: 'Signing out…',
    submenuOf: '{{title}} submenu',
    pendingLeaves_one: '{{count}} pending leave request',
    pendingLeaves_other: '{{count}} pending leave requests',
    themeLight: 'Light theme',
    themeDark: 'Dark theme',
    switchToLight: 'Switch to light theme',
    switchToDark: 'Switch to dark theme',
    account: 'Account menu',
    profile: 'Profile',
  },
  topbar: {
    search: {
      placeholder: 'Search the menu…',
      noResults: 'No results',
      open: 'Search the menu',
      close: 'Close search',
    },
    tasks: 'My tasks',
    newTasks_one: '{{count}} new task',
    newTasks_other: '{{count}} new tasks',
    unreadMessages: 'Unread messages',
    pendingLeaves: 'Pending leave requests',
  },
  missedCalls: {
    button: 'Missed calls',
    title: 'Missed calls',
    markAllRead: 'Mark all as read',
    missedVoice: 'Missed voice call',
    missedVideo: 'Missed video call',
    callBackVoice: 'Call back (voice)',
    callBackVideo: 'Call back (video)',
    markRead: 'Mark as read',
  },
  dashboard: {
    subtitle: 'Welcome to the company portal. Carry out your work and find your information here.',
    tasks: {
      title: 'To-do list',
      newBadge: '{{count}} new',
      unseen_one: 'You have {{count}} new task assigned to you. Take a look.',
      unseen_other: 'You have {{count}} new tasks assigned to you. Take a look.',
      calm: 'View and follow the tasks assigned to you.',
    },
    quickLinks: 'Quick access',
    links: {
      calendar: { title: 'My calendar', description: 'View and manage your tasks.' },
      projects: { title: 'My projects', description: 'Follow and update your projects.' },
      announcements: { title: 'Announcements', description: 'Keep up with company announcements.' },
      manual: { title: 'User guide (old system)', description: 'The old portal’s PDF guide.' },
    },
  },
  tasks: {
    title: 'My tasks',
    subtitle_one: '{{count}} open task',
    subtitle_other: '{{count}} open tasks',
    stats: {
      pending: 'Pending',
      inProgress: 'In progress',
      completed: 'Completed',
      overdue: 'Overdue',
    },
    filters: {
      active: 'Active',
      completed: 'Completed',
      all: 'All',
    },
    loading: 'Loading tasks…',
    emptyActive: 'You have no active tasks',
    empty: 'No tasks found',
    newBadge: 'New',
    overdue: 'Overdue',
    assignees: 'Assigned to',
    changeStatus: 'Change status',
    status: {
      pending: 'Pending',
      'in-progress': 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
  },
  projects: {
    title: 'Projects',
    assignedOnly: 'Assigned projects',
    allProjects: 'All projects',
    showAll: 'Show all projects',
    showAssigned: 'Show assigned projects only',
    export: 'Export report',
    exporting: 'Preparing…',
    searchPlaceholder: 'Search by code, protocol, name, customer, center or role…',
    assignmentStatus: 'Assignment',
    projectStatus: 'Project status',
    count_one: '{{count}} project',
    count_other: '{{count}} projects',
    columns: {
      code: 'Code',
      protocol: 'Protocol no.',
      date: 'Start date',
      name: 'Project name',
      assignment: 'Assignment',
      status: 'Status',
      fte: 'FTE',
      action: 'Action',
    },
    loading: 'Loading projects…',
    emptyAssigned: 'No projects are assigned to this employee.',
    emptyAll: 'There are no projects.',
    emptyFiltered: 'No projects match your search and filters.',
    unassigned: 'Not assigned',
    hourly: 'Hourly',
    detail: 'Details',
    toast: {
      loadError: 'Projects could not be loaded.',
      nothingToExport: 'There are no projects to export.',
      exportSuccess: 'Report created.',
      exportError: 'The report could not be created.',
    },
  },
  projectDetail: {
    fallbackTitle: 'Project details',
    protocol: 'Protocol no.',
    customer: 'Customer',
    startDate: 'Start date',
    endDate: 'End date',
    projectStatus: 'Project status',
    assignmentStatus: 'Assignment',
    centersTitle: 'Centers and roles',
    noCenters: 'No center assignments are recorded for this employee.',
    columns: {
      center: 'Center',
      role: 'Role',
      workerType: 'Worker type',
      blinding: 'Blinding',
      assignedAt: 'Assigned on',
      rate: 'Rate',
      status: 'Status',
    },
    unspecified: 'Not specified',
    summaryTitle: 'Patients and visits',
    summaryHint: 'This employee’s records only',
    loadingSummary: 'Loading summary…',
    summaryError: 'The project summary could not be loaded.',
    patients: 'Patients',
    homeVisitPatients: 'Home-visit patients',
    visits: 'Visits',
    patientStatus: {
      planned: 'Planned',
      screened: 'Screened',
      screenFail: 'Screen fail',
      enrolled: 'Enrolled',
      active: 'Active',
      onMedication: 'On medication',
      completed: 'Completed',
      withdrawn: 'Withdrawn',
    },
  },
  welcome: {
    badge: 'Welcome aboard',
    greeting: 'Hello, {{name}}!',
    greetingNoName: 'Hello!',
    intro: 'This is your first sign-in to the HabcareCRO Management Portal. From here you can manage your tasks, projects, leave and personnel records in one place.',
    steps: {
      profile: {
        title: 'Complete your profile',
        description: 'Update your contact details and CV so your profile is complete.',
      },
      tasks: {
        title: 'Follow your tasks',
        description: 'See the tasks assigned to you in the "To-do list" and update their status.',
      },
      calendar: {
        title: 'Calendar and projects',
        description: 'Follow your plans in your calendar and the projects you work on under "My projects".',
      },
      security: {
        title: 'Keep your account safe',
        description: 'Please change the temporary password we emailed you as soon as you can.',
      },
    },
    footer: 'If you have any questions, our Human Resources team will be glad to help. We wish you every success!',
    manual: 'User guide',
    start: 'Let’s get started',
  },
  manual: {
    title: 'User guide (old system)',
    loading: 'Loading the guide…',
    error: 'The PDF could not be loaded. Please try again later.',
    languageNote: 'The guide is currently available in Turkish only.',
    openInNewTab: 'Open in new tab',
  },
  underConstruction: {
    badge: 'In development',
    title: 'This page is under development',
    text: 'Our team is working on this page. It will be here once it is ready; until then you can keep using the other pages.',
    progress: 'Development in progress',
    steps: { design: 'Design', build: 'Development', test: 'Testing' },
    address: 'Requested address:',
    back: 'Go Back',
    home: 'Back to Home',
  },
  employees,
  dataTable,
  customers,
  login,
  projectManagement,
  profilePage,
  visitModal,
  cargo,
  operations,
  quality,
  smoLead,
  regionReports,
  loginReminders,
  leaves,
  stock,
  tariffs,
  centers,
  budget,
  userGuide,
  errorReports,
  pageAccess,
  todo,
  insurance,
  educationReports,
  bankAccounts,
  employeeFinance,
  salaryPayment,
  projectFinance,
  fieldExpenses,
  externalPersonnel,
  employeeReports,
  employeeAnalysis,
  dataEntryValues,
  // Menu titles by route path (Turkish uses menuConfig's titles)
  menu: {
    '/dashboard': 'Home',
    '/todo-list': 'To-do list',
    '/profile': 'Profile',
    '/calisan': 'Employees',
    '/employee-management': 'Employee management',
    '/employee-insurance': 'Insurance',
    '/izin-yonetimi': 'Leave management',
    '/error-reports': 'Employee error feedback',
    '/sayfa-yetkileri': 'Page permissions',
    '/musteri': 'Customers',
    '/customer-management': 'Customer management',
    '/proje': 'Projects',
    '/projects-management': 'Project management',
    '/sponsor': 'Tariffs / Subcontractors',
    '/sponsor-management': 'Subcontractor / tariff management',
    '/operasyon': 'Operations',
    '/operation-management': 'Operations management',
    '/stok': 'Stock',
    '/stock-management': 'Stock management',
    '/kalite': 'Quality',
    '/quality-management': 'Quality management',
    '/belge-kontrol': 'Document check',
    '/egitim': 'Training',
    '/education-management': 'Training management',
    '/training-calendar': 'Training calendar',
    '/education-reports': 'Training reports',
    '/finans': 'Finance',
    '/budget-management': 'General finance',
    '/kredi-sigorta-yonetimi': 'Loans & insurance',
    '/genel-butce-yonetimi': 'General budget',
    '/bank-account-management': 'Bank accounts',
    '/salary-payment': 'Salary payments',
    '/project-finance-management': 'Project finance',
    '/employee-finance-management': 'Employee finance',
    '/saha-masraflari': 'Field expenses',
    '/raporlar': 'Reports',
    '/smo-lead-reports': 'SMO lead reports',
    '/bolge-muduru-reports': 'Regional manager reports',
    '/employee-reports': 'Employee reports',
    '/employee-analysis': 'Employee analysis',
    '/tanimlamalar': 'Definitions',
    '/center-management': 'Center management',
    '/external-personnel-management': 'External personnel',
    '/data-entry-values': 'Data entry values',
  },
};

export default en;
